import { Fancybox } from "@fancyapps/ui";

const supportedGalleries = [
  {
    container: '[data-component="rich-text"]',
    selector: 'figure.wp-caption img',
    minimum: 2
  },
  {
    container: '[data-component="gallery"]',
    selector: 'figure.cmoa-image img',
    minimum: 1
  },
  {
    container: '.sidebar-modules [data-component="slider"]',
    selector: 'figure.cmoa-image img',
    minimum: 1
  }
];

// Init a gallery instance scoped per container
supportedGalleries.forEach(({ container, selector, minimum }) => {
  const $containers = Array.from(document.querySelectorAll(container))
  $containers.forEach($container => {
    const $images = Array.from($container.querySelectorAll(selector))
    if ($images.length >= minimum) {
      initGallery($images)
    }
  })
})

// Given a set of img nodes, create fancybox gallery
// when clicking on an img
function initGallery ($images) {
  // Prepare a list of gallery items for Fancybox
  const galleryItems = $images.map((img) => {
    const figure = img.closest('figure');
    const figcaption = figure.querySelector('figcaption');
    img.classList.add('cursor-zoom-in');
    return {
      src: img.src,
      caption: figcaption ? figcaption.innerHTML : ''
    };
  });

  // Attach Fancybox click event to images
  $images.forEach((img, index) => {
    img.addEventListener('click', (e) => {
      e.preventDefault();
      new Fancybox(galleryItems, {
        startIndex: index, // start at the current index
        contentClick: 'next', // clicking on an image goes to next slide
        commonCaption: true, // turn on single element caption
        wheel: false, // de-activate any functionality on mousewheel
        idle: false, // de-activate icons disappearing when idle
        showClass: 'f-fadeSlowIn',
        compact: () => window.matchMedia("(max-width: 639px)")?.matches, // update compact mode to align to tailwind sm breakpoint
        Carousel: {
          transition: 'fade',
          Navigation: {
            nextTpl: "&rarr;",
            prevTpl: "&larr;",
          },
        },
        Toolbar: {
          items: {
            // create a custom buttons so we can use the font glyphs
            close: {
              tpl: `<button class="f-button" data-fancybox-close>&#10005;</button>`,
            },
            prev: {
              tpl: `<button class="f-button flex sm:!hidden" title="Previous" data-fancybox-prev>&larr;</button>`
            },
            next: {
              tpl: `<button class="f-button flex sm:!hidden" title="Next" data-fancybox-next>&rarr;</button>`
            }
          },
          display: {
            left: ['prev', 'next'],
            middle: [],
            right: ['close'],
          },
        },
        Slideshow: false, // disable autoplay slideshow functionality
        Thumbs: false // disable thumbnail navigation
      });
    });
  });
}